export const APP_TITLE = 'スタディサプリ for PARENTS';

export const pageTitles = {
  contact: 'よくある質問・お問い合わせ',
  forgot: 'ログインできない場合',
  forgotPasswordConfirmation: 'パスワードの再設定',
  login: 'ログイン',
  mypage: 'マイページ',
  mypageOrganizationMembershipsNewV2: '生徒の追加',
  mypageOrganizationMembershipsConfirm: '確認画面',
  mypageOrganizationMembershipsComplete: '登録完了',
  mypageOrganizationMembershipsError: '生徒情報が一致しない場合',
  passwordReset: 'パスワードの再設定',
  registration: 'メールアドレスの設定',
  registrationProfile: 'アカウントの設定',
  registrationProfileError: '生徒情報が一致しない場合',
  withdrawal: '退会について',
  notices: '運営からのお知らせ',
  absences: '欠席連絡',
  shinroInformations: '高校生の保護者のための進路お役立ち情報',
  announcements: '先生からのお知らせ',
  emailChangeTokens: 'メールアドレスの再設定',
  accountRegistration: 'アカウントの仮登録',
  accountRegistrationConfirmation: '確認画面',
  inviteEmailInput: 'メールアドレスの入力',
  inviteEmailConfirm: '確認画面',
  inviteEmailComplete: '送信完了',
  invitationStudentConfirm: '招待された生徒の確認',
  invitationRegisterInput: 'アカウント登録',
  invitationRegisterConfirm: '確認画面',
  invitationRegisterComplete: '本登録完了',
  invitationRegisterError: '確認画面',
} as const;
